/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminnav_Toggle1Inputs */

const en_adminnav_toggle1 = /** @type {(inputs: Adminnav_Toggle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle admin settings`)
};

/** @type {(inputs: Adminnav_Toggle1Inputs) => LocalizedString} */
const zh_adminnav_toggle1 = () => /** @type {LocalizedString} */ ('adminNav_toggle')

/** @type {(inputs: Adminnav_Toggle1Inputs) => LocalizedString} */
const es_adminnav_toggle1 = zh_adminnav_toggle1;

/**
* | output |
* | --- |
* | "Toggle admin settings" |
*
* @param {Adminnav_Toggle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminnav_toggle1 = /** @type {((inputs?: Adminnav_Toggle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminnav_Toggle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminnav_toggle1(inputs)
	if (locale === "en") return en_adminnav_toggle1(inputs)
	return es_adminnav_toggle1(inputs)
});
export { adminnav_toggle1 as "adminNav_toggle" }